import { useCallback, useEffect, useState } from "react";

const KEY = "fav_schools_v1";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };

export function useFavorites() {
  const [codes, setCodes] = useState(read);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(codes)); }, [codes]);

  const toggle = useCallback((c) => setCodes((arr) => (arr.includes(c) ? arr.filter((x) => x !== c) : [...arr, c])), []);
  const move = useCallback((c, dir) => setCodes((arr) => {
    const i = arr.indexOf(c), j = i + dir;
    if (i < 0 || j < 0 || j >= arr.length) return arr;
    const next = [...arr]; [next[i], next[j]] = [next[j], next[i]];
    return next;
  }), []);
  const clear = useCallback(() => setCodes([]), []);

  return { codes, has: (c) => codes.includes(c), toggle, move, clear };
}
